<script lang="ts">
    import vm, { JourneyNode, JourneyTextNode } from '@journeys/Journeys.viewmodel';
    import { computed, ComputedRef, inject, onUnmounted, ref } from 'vue';
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';
    // assets
    // import HSLColors from '@cwd/shared/components/ColorPickers/HSLColorValues'
    // import { HeartSVG } from '@shared/assets/vector/ui/IconsUI'

    // components

    // import NodePresetList from './Partials/NodePresetList.vue'
    import FluidButton from '@cwd/shared/components/FluidButton.vue';
    // import NodeTemplate from '../../NodePartials/NodeTemplate.vue'

    // import NodeTypeSegment from './Partials/NodeTypeSegment.vue'

    // tabs
    import TabData from '@cwd/journeys/components/UserInterface/Menues/Tabs/NodeSettingsData.vue';
    // import TabAdvanced from './Tabs/NodeSettingsAdvanced.vue'
    import TabConditions from './Tabs/NodeConditions.vue';

    // assets
    import { NodeConditionVariation, NodeType } from '@cwd/Journeys/Enums';
    import { CrossSVG /*, SingleArrowLeftSVG, SingleArrowRightSVG*/ } from '@shared/assets/vector/ui/IconsUI';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { FeatureService } from '@shared/directives/Feature.service';
    // import { ENode } from '@cwd/Journeys/binaryWorker';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'Menu_NodeSettings',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const { editor, account } = vm;
    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const featureAccess: FeatureService = injectorAccess.injector.get(FeatureService);

    onUnmounted(() => {
        editor.events.removeListener('setselectionkey');
    });

    let selectionIndex = ref(0);
    const selectedItems: ComputedRef<any> = computed(() => {
        let node_list = Object.values<JourneyNode | JourneyTextNode>(editor.tools.sel_nodes),
            point_list = Object.values(editor.tools.sel_points);

        for (let i = 0; i < node_list.length; i++)
            if (node_list[i].id === editor.tools.sel_keyObj) {
                selectionIndex.value = i;
                if (node_list[i].data.type === NodeType.Condition && (node_list[i] as JourneyNode).data.var === NodeConditionVariation.Delay)
                    editor.state.nodeSettingsTab = 'data';
                break;
            }

        return { nodes: node_list, points: point_list };
    });

    editor.events.addListener('setselectionkey', (id: number) => {
        editor.tools.sel_keyObj = id;

        selectedItems.value.nodes.find((n: JourneyNode, idx: number) => {
            if (n.id === id) {
                selectionIndex.value = idx;
                return true;
            }
            return false;
        });
    });
</script>

<template>
    <div v-if="selectedItems.nodes[selectionIndex]" class="menu-container" :class="editor.state.showNodeMenu && 'show-node-menu'">
        <!--
        <div class="static-container">
			<template v-if="editor.dev.show.admin_tools">
				<div class="tab-container fl">
					<FluidButton
						text="Data"
						class="tab-underline"
						:class="editor.state.nodeSettingsTab === 'data' ? 'active' : ''"
						@click="() => switchTab('data')" />

					<FluidButton
						text="Appearance"
						class="tab-underline"
						:class="editor.state.nodeSettingsTab === 'appearance' ? 'active' : ''"
						@click="() => switchTab('appearance')" />
				</div>
			</template>
		</div>
        -->

        <template v-if="editor.state.nodeSettingsTab === 'data'">
            <ScrollableContainer>
                <h2 class="h3 d-flex">
                    {{ $Resources.NodeTaskSettings }}

                    <FluidButton
                        :text="$Resources.CloseBtn"
                        textClasses="sr-only"
                        :icon="CrossSVG"
                        iconClasses="lg"
                        class="btn btn-subtle btn-sm m-auto-l"
                        @click="() => (editor.state.showNodeMenu = false)" />
                </h2>

                <TabData :node="selectedItems.nodes[selectionIndex]" />

                <template
                    v-if="
                        !(
                            selectedItems.nodes[selectionIndex].data.type === NodeType.Condition &&
                            selectedItems.nodes[selectionIndex].data.var === NodeConditionVariation.Delay
                        ) &&
                        selectedItems.nodes[selectionIndex].data.type !== NodeType.Page &&
                        !(
                            selectedItems.nodes[selectionIndex].data.segment.Segments &&
                            selectedItems.nodes[selectionIndex].data.segment.Segments.length > 0 &&
                            selectedItems.nodes[selectionIndex].data.segment.Segments[0].Type === 'InteractionSegment'
                        )
                    ">
                    <TabConditions :node="selectedItems.nodes[selectionIndex]" class="pt-sm" />
                </template>
            </ScrollableContainer>
        </template>

        <!--
		<template v-else-if="editor.state.nodeSettingsTab === 'appearance'">
			<TabAppearance :node="selectedItems.nodes[selectionIndex]" />
		</template>

		<template v-if="editor.dev.show.admin_tools">
			<div class="static-container bottom">
				<transition name="expand" style="height: 3.5rem; overflow: hidden">
					<div v-if="savePresetActive">
						<h4 class="subheading">{{ $Resources.NameLabel }}:</h4>
						<FluidInput style="margin: 0" class="subheading minimal" v-model:value="presetName" />
					</div>
				</transition>

				<div>
					<FluidButton
						class="large fw tt-uppercase mv-xxs"
						:class="savePresetActive || 'border'"
						:text="$Resources.NodeSavePresetLabel"
						@click="() => handleSavePreset()" />
					<transition name="expand" style="height: 1.7rem">
						<div v-if="savePresetActive">
							<FluidButton class="text-button fl-0" :text="$Resources.CancelButton" @click="() => handleSavePreset(true)" />
						</div>
					</transition>
				</div>
			</div>
		</template>
        -->
    </div>
</template>

<style>
    .expand-enter-active,
    .expand-leave-active {
        /* height: 3rem; */
        transition-property: opacity, height;
        transition-duration: 0.3s;
        transition-timing-function: ease;
    }

    .expand-leave-to,
    .expand-enter-from {
        height: 0 !important;
        opacity: 0;
    }

    .menu-container {
        display: flex;
        flex-flow: column;
        position: relative;
        height: 100%;
        max-height: 100vh;
        overflow: hidden;
    }

    .static-container.bottom {
        flex-direction: column;
        padding: 0.3rem 0.4rem 0.4rem 0.2rem;
    }

    .menu-quickaccess {
        margin: 0.2rem 0 0.2rem -0.25rem;
    }
    .static-container {
        z-index: 2;
    }
    .preview-window {
        display: flex;
        position: relative;
        flex-direction: column;
        height: 10rem;
        flex-shrink: 0;
        flex-grow: 0;

        background-color: #1f1c26;
        border-radius: 0.2rem;
        margin-bottom: 0.4rem;
        padding: 0.5rem 0.6rem 0rem 0.6rem;
    }

    .preview-node {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .preview-node,
    .preview-node .node-vector {
        height: 75%;
        transform: scale(1.1);
    }

    .preview-title-wrapper {
        position: relative;
        left: 0;
        right: 0;
        height: 1.3rem;
        flex-shrink: 0;
        flex-grow: 0;
        margin: 0 auto;
        width: 70%;
    }

    .preview-bottom-wrapper {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        flex-grow: 0;
        left: 0;
        right: 0;
        flex-shrink: 0;
        margin: 0 auto;
        width: 80%;
    }

    .preview-window .favorites-button {
        position: absolute;
        top: 0.3rem;
        right: 0.3rem;
    }

    .selection-idx {
        height: 0.25rem;
        width: 0.25rem;
        margin: 0.3rem 3.5%;
        background-color: rgba(255, 255, 255, 0.116);
        border-radius: 0.3rem;
    }
    .selection-idx.active {
        transform: scale(1.15);
        background-color: rgba(255, 255, 255, 0.493);
    }

    .navigation-group {
        display: flex;
        justify-content: space-between;
        position: absolute;
        width: 94%;
        height: 2rem;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    .navigation-group .fluid-button {
        width: 2rem;
    }

    .navigation-group svg {
        height: 1.2rem;

        fill: rgba(255, 255, 255, 0.322);
    }

    .navigation-group svg:hover {
        fill: rgba(255, 255, 255, 0.801);
    }

    .invisible {
        opacity: 0;
        pointer-events: none;
    }

    .preview-window .favorites-button {
        position: absolute;
        display: block;
        top: 0.7rem;
        right: 0.8rem;
        fill: rgba(224, 224, 224, 0);
        stroke-width: 0.5rem;
        stroke: rgba(240, 248, 255, 0.192);
        opacity: 1;
        height: 1.4rem;
        width: 1.4rem;

        transition-property: fill, stroke;
        transition-duration: 0.14s;
        transition-timing-function: ease;
    }

    .preview-window .favorites-button:hover {
        stroke: rgb(240, 248, 255);
        background: none;
        cursor: pointer;
    }

    .preview-window .favorites-button.active {
        stroke: rgba(240, 248, 255, 0.158);
        fill: rgba(255, 255, 255, 0.767);
        background: none;
        cursor: pointer;
    }
    .preview-window .favorites-button.active:hover {
        fill: rgb(255, 255, 255);
    }
</style>
